/**
 * Seuils d'alerte du pilotage prévision et réappro (décision du 28/10) : les mêmes pour tout le
 * monde, versionnés en base (`forecast_alert_thresholds`), chaque version avec son motif. Point de
 * vérité des valeurs permises, que le schéma Vine du backend et la modale « Réglages » appliquent
 * tous deux. Sans dépendance runtime : exporté par le barrel.
 */

/**
 * Écart avec S-1 : une prévision est en alerte quand elle s'écarte de plus de ±x % des ventes
 * réelles du même jour S-1.
 */
export const FORECAST_ALERT_S1_GAP_PCTS = [5, 10, 15, 20] as const
export type ForecastAlertS1GapPct = (typeof FORECAST_ALERT_S1_GAP_PCTS)[number]

/**
 * Niveau k de surproduction : une ligne est en alerte quand son coef de sécurité dépasse
 * 1 + k × la volatilité du jour.
 */
export const FORECAST_ALERT_OVERPRODUCTION_KS = [1, 1.5, 2] as const
export type ForecastAlertOverproductionK = (typeof FORECAST_ALERT_OVERPRODUCTION_KS)[number]

export interface ForecastAlertThresholdsValues {
  s1GapPct: ForecastAlertS1GapPct
  overproductionK: ForecastAlertOverproductionK
}

/** Seuils tant qu'aucune version n'a été enregistrée. */
export const FORECAST_ALERT_THRESHOLDS_DEFAULTS = {
  s1GapPct: 10,
  overproductionK: 1.5,
} as const satisfies ForecastAlertThresholdsValues

export const sameAlertThresholds = (
  a: ForecastAlertThresholdsValues,
  b: ForecastAlertThresholdsValues,
): boolean => a.s1GapPct === b.s1GapPct && a.overproductionK === b.overproductionK
